import { Card, Stack, type StackProps, Typography } from "@mui/material"
import type { PropsWithChildren, ReactNode } from "react"
import { CARD_PX } from "../../common"
import {
  AsideSectionSummaryMainSubTitle,
  type AsideSectionSummaryMainSubTitleProps,
} from "../common"

export type AsideSectionSummaryMainCardProps = {
  title: string
  titleInfo?: ReactNode
  subTitle?: ReactNode
  alignItems?: StackProps["alignItems"]
  childrenContainerSlotProps?: StackProps
} & AsideSectionSummaryMainSubTitleProps

export const AsideSectionSummaryMainCard = (
  props: PropsWithChildren<AsideSectionSummaryMainCardProps>,
) => {
  const {
    title,
    titleInfo,
    subTitle,
    subtitleColor,
    childrenContainerSlotProps,
    alignItems = "inherit",
  } = props

  return (
    <Card
      component={Stack}
      px={CARD_PX}
      py={3}
      sx={{ border: "none", bgcolor: (theme) => theme.palette.common.ghostBlue }}
      alignItems={alignItems}
      flex={1}
    >
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="flex-end"
        gap={2}
        width="100%"
        mb={1}
      >
        <Typography
          variant="18px"
          fontWeight={600}
          color="primary.dark1"
          textTransform="uppercase"
          sx={{ textWrap: "balance" }}
        >
          {title}
        </Typography>
        {titleInfo}
      </Stack>
      {subTitle && (
        <AsideSectionSummaryMainSubTitle subtitleColor={subtitleColor}>
          {subTitle}
        </AsideSectionSummaryMainSubTitle>
      )}
      <Stack
        {...childrenContainerSlotProps}
        sx={{ gap: 5, ...childrenContainerSlotProps?.sx }}
      >
        {props.children}
      </Stack>
    </Card>
  )
}
